import React from 'react';

import SubscriptionModal from '../generalComponents/SubscriptionModal';

import { PlayArrow } from '@material-ui/icons';

import * as moment from 'moment';
import { isMobile } from 'react-device-detect';

class PlayerInfo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showTranscript: false,
            showSubscriptionModal: false
        };
    }

    handleClick = (programSegment, index) => {
        const { changeVideoSrc, clearReconnectInterval } = this.props;
        changeVideoSrc(programSegment, index);
        clearReconnectInterval();
    };

    handleTranscript = () => {
        const { showTranscript } = this.state;
        const { programSegments, currentPosition } = this.props;
        if (programSegments[currentPosition].description !== '') {
            this.setState({ showTranscript: !showTranscript });
        }
    };

    getDayOfWeek = date => {
        const dayNum = new moment(date).utc().day();
        switch (dayNum) {
            case 0:
                return 'Sunday';
            case 1:
                return 'Monday';
            case 2:
                return 'Tuesday';
            case 3:
                return 'Wednesday';
            case 4:
                return 'Thursday';
            case 5:
                return 'Friday';
            case 6:
                return 'Saturday';
            default:
                break;
        }
    };

    truncate = (text, suffix = ' ...') => {
        const parser = new DOMParser();
        const parsedText = parser.parseFromString(text, 'text/html')
            .documentElement.textContent;
        const maxCharLength = 110;
        const shouldUseSuffix = maxCharLength < parsedText.length;
        return `${parsedText.substring(0, maxCharLength)}${
            shouldUseSuffix ? suffix : ''
        }`;
    };

    getTitleDate = () => {
        const { programSegments, currentPosition, program } = this.props;
        if (programSegments[currentPosition]) {
            const timestamp = program.title ? program.title : program.programDate ? program.programDate : program.publishedAt;
            const day = this.getDayOfWeek(timestamp);
            const date = moment(timestamp).utc().format('LL');
            return `${day} ${date}`;
        }
        if (programSegments.segment) {
            return (
                programSegments.anchors[0] &&
                `${programSegments.anchors[0].name} in ${
                    programSegments.segment.name
                }`
            );
        }
    };

    openSubscriptionModal = () => {
        window.location.href = '/account/purchase';
    };

    closeSubscriptionModal = () => {
        this.setState({
            showSubscriptionModal: false
        });
    };

    render() {
        const {
            programSegments,
            currentPosition,
            isSubscribed,
            user,
            forceHideNextSegmentButton,
            program
        } = this.props;
        const { showTranscript } = this.state;
        const isAnchor = user.user && user.user.account.anchor;
        const canSeeNextSegment = !forceHideNextSegmentButton && !isSubscribed && !isAnchor;
        return ( programSegments &&
            <>
            <div className={`player-info ${isMobile && !isSubscribed && 'mobile-subscribe-position'}`}>
                {!isMobile &&
                    <div className="player-title">
                        <div className="player-title-name">
                            {programSegments[currentPosition].segment.name !== '' ? programSegments[currentPosition].segment.name : program.nextSegmentCategory}
                            <div className="player-title-date">
                                {this.getTitleDate()}
                            </div>
                        </div>
                        <div className="player-title-tags" />
                    </div>}
                    {!isSubscribed && (
                        <div className='subscribe-btn-wrapper'>
                            <button onClick={this.openSubscriptionModal} className='subscribe-btn'>SUBSCRIBE</button>
                        </div>
                    )
                    }
                    {/* canSeeNextSegment && (
                        <div className="player-next-segment segment">
                            <div
                                className="player-next-segment-title"
                                onClick={this.openSubscriptionModal}
                            >
                                <div className="player-next-segment-title-label">
                                    Next Segment
                                </div>
                                <div className="player-next-segment-title-name">
                                    {this.props.program.nextSegmentCategory}
                                </div>
                            </div>
                            <div
                                className="player-next-segment-cover"
                                onClick={this.openSubscriptionModal}
                            >
                                <img
                                    src={this.props.program.nextImageUrl}
                                    alt="Next Segment"
                                />
                                <PlayArrow fontSize="large" />
                            </div>
                        </div>
                    ) */}
                </div>
                <SubscriptionModal
                    show={this.state.showSubscriptionModal}
                    closeModal={this.closeSubscriptionModal}
                />
                {(isSubscribed || isAnchor)  && (
                    <>
                        <div className="video-transcript clearfix">
                            <a
                                href="javascript:void(0);"
                                className={showTranscript ? 'in' : ''}
                                onClick={this.handleTranscript}
                            >
                                <span className="h3 text-white">
                                    Transcript
                                </span>
                                <span
                                    className="copy"
                                    style={{ marginRight: '5px' }}
                                >
                                    {programSegments[currentPosition].description !== '' ? this.truncate(programSegments[currentPosition].description) : 'N/A'}
                                </span>
                                {programSegments[currentPosition].description !== '' && (<span className="link">
                                    <span className="more">
                                        Read More &gt;&gt;
                                    </span>
                                    <span className="hide-btn">
                                        Hide &gt;&gt;
                                    </span>
                                </span>)}
                            </a>
                            <div
                                className={
                                    showTranscript
                                        ? 'collapse in'
                                        : 'collapse'
                                }
                                dangerouslySetInnerHTML={{
                                    __html: programSegments[currentPosition].description !== '' ? programSegments[currentPosition].description : 'N/A'
                                }}
                            />
                        </div>
                    </>
                )}
            </>
        );
    }
}
export default PlayerInfo;
